import { z } from 'zod';
export const MAX_DOCUMENT_BYTES = 10 * 1024 * 1024;
export const chatDocumentSchema = z.strictObject({
  id: z
    .uuid()
    .regex(/^[a-f0-9-]{36}$/)
    .refine((v) => v[14] === '7'),
  pageCount: z.number().int().min(1).max(200),
  sizeBytes: z.number().int().min(16).max(MAX_DOCUMENT_BYTES),
});
